import React from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import Truncate from 'react-truncate';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  CONTENT_IMAGE_PLACEHOLDER,
} from '../../../../config/constants';

import './style.scss';

const NEWS_TYPE = 'news';

const NodeArticleTeaser = ({ entity }) => {
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  const title = entity.getIn(['title', 0, 'value'], '');
  const bodyStripped = entity.getIn(['body', 0, 'processed'], '').replace(/(<([^>]+)>)/ig, '');
  const summary = entity.getIn(['body', 0, 'summary'], '');
  const hero = entity.getIn(['field_image', 0, 'styles'], '');
  const url = entity.getIn(['paths', currentLanguage], '');
  const createdDate = entity.getIn(['created', 0, 'value'], '');
  const formattedDate = format(new Date(createdDate), 'd MMMM');
  const articleType = entity.getIn(['field_article_type', 0, 'entity', 'field_system_name', 0, 'value'], '');

  return (
    <article className="Teaser NodeArticleTeaser">
      <CoreLink to={url}>
        <div className="NodeArticleTeaser__imageWrapper">
          <div className="NodeArticleTeaser__imageWrapper--overlay" />
          {hero ? (
            <Image
              lazyload
              includeWebP
              alt={title}
              src={{
                [SCREEN_MOBILE]: hero.getIn(['crop_4_3']),
                [SCREEN_TABLET]: hero.getIn(['crop_4_3']),
                [SCREEN_NORMAL]: hero.getIn(['crop_4_3']),
              }}
            />
          ) : <img src={CONTENT_IMAGE_PLACEHOLDER} alt="Content placeholder" />}
          {articleType === NEWS_TYPE
            && <div className={`NodeArticleTeaser__imageWrapper__date ${!hero && 'green'}`}>{formattedDate}</div>}
        </div>

        <div className="NodeArticleTeaser__textWrapper">
          <div className="NodeArticleTeaser__title-wrapper">
            <h2 className="NodeArticleTeaser__title asH3">
              <Truncate lines={2} ellipsis="...">{title}</Truncate>
            </h2>
            <i className="icon icon-arrow-right" />
          </div>

          <div className="NodeArticleTeaser__textWrapper__body">
            <Truncate lines={4} ellipsis="...">
              <WysiwygField
                property="schema:text"
                html={(summary !== '' ? summary : bodyStripped)}
              />
            </Truncate>
          </div>
        </div>
      </CoreLink>
    </article>
  );
};

export default NodeArticleTeaser;
